export default {
  title: 'Nice!',
  subtitle: {
    normal: 'You have a reward',
    percent: 'You earned %{percent}% progress towards your first reward!',
  },
  finishAccount: 'Finish your account',
  rewardText: 'Ready to redeem',
}
